import React from "react";
import { makeStyles } from "@mui/styles";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import BlogCard from "../../common/BlogCard";

const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: TOP_PADDING,
    paddingBottom: SIDE_PADDING,
    paddingLeft: SIDE_PADDING,

    backgroundColor: theme.palette.primary.light,
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
}));

const Blogs = (props) => {
  const classes = usestyles();
  const blogsList = props.blogsList || [];

  return (
    <div className={classes.root}>
      {blogsList.map((blog, index) => {
        return <BlogCard key={index} data={blog} />;
      })}
    </div>
  );
};

export default Blogs;
